import Component from 'vue-class-component';
import { Prop, Watch, Vue } from 'vue-property-decorator';

@Component
export default class TableFilterStringComponent extends Vue {
  @Prop()
  fieldName: string;

  @Prop()
  criteriaType: string;

  value = '';

  @Watch('value')
  onPropertyChanged() {
    setTimeout(
      function () {
        this.$emit('updateCriteria', this.fieldName + '.' + this.criteriaType, this.value);
      }.bind(this),
      500
    );
  }
}
